import theme from '@hellodarwin/core/lib/theme';
const commonIcons = {
    Group1Filled: {
        icon: 'Group1Filled',
        color: theme.colors.beige_4,
        width: 1086,
        height: 993,
        margin: -239,
        side: 'right',
    },
    Group3Outlined: {
        icon: 'Group3Outlined',
        width: 1006,
        height: 1006,
        margin: -301,
        side: 'right',
    },
};
const sections = {
    intro: {
        icons: [
            {
                icon: 'Group3Outlined',
                color: theme.colors.beige_4,
                top: -75,
                margin: 0,
                width: 448,
                height: 548,
                side: 'left',
            },
        ],
    },
    'row-banner': {
        icons: [
            {
                icon: 'Group4Outlined',
                top: -140,
                margin: -250,
                width: 508,
                height: 430,
                rotate: -29,
                color: 'inherit',
                side: 'left',
                desktopOnly: true,
            },
            {
                icon: 'Group2Outlined',
                top: -160,
                width: 508,
                height: 430,
                rotate: 100,
                margin: -250,
                color: 'inherit',
                side: 'right',
            },
        ],
    },
    'column-banner': {
        icons: [
            {
                icon: 'Group3Outlined',
                height: 600,
                top: -130,
                margin: -100,
                width: 450,
                color: 'inherit',
                side: 'left',
                desktopOnly: true,
            },
            {
                icon: 'Group3Outlined',
                height: 500,
                top: -75,
                rotate: 92,
                margin: -75,
                width: 450,
                color: 'inherit',
                side: 'right',
            },
        ],
    },
    faq: {
        backgroundColor: theme.colors.beige_1,
        icons: [
            {
                icon: 'Group1Outlined',
                rotate: -5,
                margin: -500,
                top: 300,
                width: 1063,
                height: 750,
                color: theme.colors.beige_1,
                side: 'left',
            },
        ],
    },
    'items-list-with-background': {
        icons: [
            {
                icon: 'Group3Outlined',
                width: 705,
                height: 843,
                top: -28,
                margin: -147,
                color: theme.colors.beige_3,
                side: 'left',
            },
        ],
    },
    'carousel-banner': {
        icons: [
            {
                icon: 'Group4Outlined',
                side: 'right',
                top: -300,
                width: 700,
                height: 1000,
                margin: -100,
                color: theme.colors.beige_1,
                inversed: true,
                desktopOnly: true,
            },
        ],
    },
    default: {
        icons: [],
    },
};
const pages = {
    'contact-us': {
        backgroundColor: theme.colors.beige_2,
        icons: [
            {
                icon: 'Group1Outlined',
                color: theme.colors.beige_4,
                top: 80,
                rotate: 180,
                margin: -191,
                width: 968,
                height: 950,
                side: 'left',
                inversed: true,
            },
        ],
    },
    applications: {
        backgroundColor: theme.colors.beige_2,
        icons: [
            Object.assign(Object.assign({}, commonIcons.Group1Filled), { top: -120, color: theme.colors.beige_1, margin: -191, side: 'right' }),
        ],
    },
    assistant: {
        backgroundColor: theme.colors.beige_2,
        icons: [
            Object.assign(Object.assign({}, commonIcons.Group1Filled), { top: -120, color: theme.colors.beige_1, margin: -191, side: 'right' }),
        ],
    },
    default: {
        icons: [],
    },
};
export const getIconContainerParams = (pageTag) => {
    var _a;
    return (_a = sections === null || sections === void 0 ? void 0 : sections[pageTag]) !== null && _a !== void 0 ? _a : sections.default;
};
export const getIconPageParams = (pageTag) => {
    var _a;
    return (_a = pages === null || pages === void 0 ? void 0 : pages[pageTag]) !== null && _a !== void 0 ? _a : pages.default;
};
